<template>
  <div class="custom-menu-action">
    <md-field>
      <md-select
        v-model="state.id"
        v-close-on-zoom
        class="grandparent-select"
        :disabled="readonly"
        @md-selected="selectGrandparent"
      >
        <md-option
          v-for="button in grandParentButtons"
          :key="button.value"
          :value="button.value"
        >
          {{ button.label }}
        </md-option>
      </md-select>
    </md-field>
    <div class="parent-container">
      <md-field>
        <md-select
          v-model="state.parentId"
          v-close-on-zoom
          class="parent-select"
          placeholder="select parent button"
          :disabled="readonly || !parentButtons.length"
          @md-selected="selectParent"
        >
          <md-option
            v-for="button in parentButtons"
            :key="button.value"
            :value="button.value"
          >
            {{ button.label }}
          </md-option>
        </md-select>
      </md-field>
      <help-tooltip v-if="parentButtonError" :show-space="false" type="error">
        <span>{{ parentButtonError.message }}</span>
      </help-tooltip>
    </div>
    <div class="child-container">
      <md-field>
        <md-select
          v-model="state.childId"
          v-close-on-zoom
          class="child-select"
          :disabled="readonly || !childButtons.length"
          @md-selected="selectChild"
        >
          <md-option
            v-for="button in childButtons"
            :key="button.value"
            :value="button.value"
          >
            {{ button.label }}
          </md-option>
        </md-select>
      </md-field>
      <help-tooltip v-if="childButtonError" :show-space="false" type="error">
        <span>{{ childButtonError.message }}</span>
      </help-tooltip>
    </div>
  </div>
</template>

<script>
import { get } from 'lodash';

import HelpTooltip from '~lib/common/components/HelpTooltip';
import nodeMixins from './mixins/NodeMixins';

export default {
  name: 'custom-menu-action',
  components: {
    HelpTooltip,
  },
  mixins: [ nodeMixins ],
  props: [
    'readonly',
    'emitter',
    'ikey',
    'getData',
    'putData',
    'control',
  ],
  data() {
    return {
      grandParentButtons: [
        { value: 'ASSESS', label: 'Assess' },
        { value: 'MONITOR', label: 'Monitor' },
        { value: 'TREAT', label: 'Treat' },
      ],
      state: {
        id: null,
        parentId: null,
        childId: null,
      },
    };
  },
  computed: {
    customMenus() {
      return this.emitter.caseConf.customMenus || [];
    },
    parentButtons() {
      const grandParentMenu = this.customMenus.find(menu => menu.category === this.state.id);
      if (!grandParentMenu) {
        return [];
      }
      const buttons = grandParentMenu.items.map(item => ({
        value: item.id,
        label: item.content.en
      }));
      if (this.state.parentId && !grandParentMenu.items.find(item => item.id === this.state.parentId)) {
        buttons.push({ value: this.state.parentId, label: '-- not found --' });
      }
      return buttons;
    },
    childItems() {
      const grandParentMenu = this.customMenus.find(menu => menu.category === this.state.id);
      if (!grandParentMenu) {
        return [];
      }
      const parentMenu = grandParentMenu.items.find(item => item.id === this.state.parentId);
      if (!parentMenu) {
        return [];
      }
      return parentMenu.children;
    },
    childButtons() {
      const buttons = this.childItems.map(item => ({
        value: item.id,
        label: item.content.en
      }));
      if (!buttons.length) {
        return [];
      }
      if (this.state.childId && !buttons.find(item => item.value === this.state.childId)) {
        buttons.push({ value: this.state.childId, label: '-- not found --'});
      }
      buttons.push({ value: undefined, label: '-- clear --' });
      return buttons;
    },
    parentButtonError() {
      return this.errors.find(error => error.metadata.errorId === 'customMenuParent');
    },
    childButtonError() {
      return this.errors.find(error => error.metadata.errorId === 'customMenuChild');
    },
  },
  mounted() {
    this.syncState();
    this.update();
  },
  methods: {
    syncState() {
      const data = this.getData(this.ikey);
      this.state.id = get(data, 'id') || 'ASSESS';
      this.state.parentId = get(data, 'parentId');
      this.state.childId = get(data, 'childId');
    },
    selectGrandparent(value) {
      this.state.id = value;
      this.state.parentId = null;
      this.state.childId = null;
      this.update();
    },
    selectParent(value) {
      this.state.parentId = value;
      this.state.childId = null;
      this.update();
    },
    selectChild(value) {
      this.state.childId = value;
      this.update();
    },
    update() {
      this.putData(this.ikey, {
        type: 'CUSTOM_MENU',
        id: this.state.id,
        parentId: this.state.parentId,
        childId: this.state.childId,
      });
      this.emitter.trigger('process', this.control);
    }
  }
}
</script>

<style scoped>
.custom-menu-action {
  display: grid;
  grid-template-columns: 1fr;
}
.parent-container,
.child-container {
  display: flex;
}
.md-field {
  margin: 0;
}
.md-select >>> .md-input {
  height: 36px;
}
</style>